/**
 * 时间控件 时分秒
 * 2017-11-17
 * Bai.Zhiming
 */
"use strict";
angular.module("trsTimepicker", []).
directive("trsTimepicker", ["$timeout", "$templateRequest", "$compile", "$filter", "$q", function($timeout, $templateRequest, $compile, $filter, $q) {
    return {
        restrict: 'A',
        replace: false,
        require: 'ngModel',
        scope: {
            model: "=ngModel",
            minTime: "="
        },
        link: function(scope, $orgElem, $attrs) {
            var bindBody, $elem;
            initStatus();
            scope.$watch("model", function(newV, oldV) {
                if (!newV) {
                    if (!!scope.status.style) scope.status.style.display = "none";
                    delete scope.status.showDate;
                    delete scope.status.tempDate;
                } else {
                    var date = new Date(Date.parse(newV));
                    scope.status.showDate = handleHour(date.getHours(), 0) + ":" + handleMinute(date.getMinutes(), 0);
                }
            });
            scope.$watch("minTime",function(newV,oldV){
            });
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    isInit: true
                };
                scope.data = {};
                replaceInput();
                initTemplate().then(function() {
                    initElemEvent();
                    initMouseWheel();
                });
            }
            /**
             * [replaceInput description] 替换input框
             * @return {[type]} [description]
             */
            function replaceInput() {
                $elem = angular.copy($orgElem);
                $elem.attr({ "ng-model": "status.showDate", "readonly": true });
                $elem.removeAttr('trs-timepicker');
                $elem = $compile($elem)(scope);
                $elem.insertBefore($orgElem);
                $orgElem.hide();
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                scope.status.tempDate = !!scope.model ? new Date(Date.parse(scope.model)) : new Date();
                var hour = scope.status.tempDate.getHours();
                var minute = scope.status.tempDate.getMinutes();
                scope.selectHour(hour);
                scope.selectMinute(minute);
            }
            /**
             * [selectHour description] 选中小时
             * @return {[type]} [description]
             */
            scope.selectHour = function(hour) {
                if (isNaN(hour)) {
                    if (hour === "down")
                        hour = handleHour(Number(scope.data.hour3), 1);
                    else
                        hour = handleHour(Number(scope.data.hour3), -1);
                }
                setHour(hour);
            };
            /**
             * [selectMinute description] 设置分钟
             * @param  {[type]} minute [description]
             * @return {[type]}        [description]
             */
            scope.selectMinute = function(minute) {
                if (isNaN(minute)) {
                    if (minute === "down")
                        minute = handleMinute(Number(scope.data.minute3), 1);
                    else
                        minute = handleMinute(Number(scope.data.minute3), -1);
                }
                setMinute(minute);
            };
            /**
             * [setTime description] 设置时间
             */
            function setHour(hour) {
                $timeout(function() {
                    hour = Number(hour);
                    scope.data.hour1 = handleHour(hour, -2);
                    scope.data.hour2 = handleHour(hour, -1);
                    scope.data.hour3 = handleHour(hour, 0);
                    scope.data.hour4 = handleHour(hour, 1);
                    scope.data.hour5 = handleHour(hour, 2);
                    scope.status.tempDate.setHours(scope.data.hour3);
                    scope.status.showDate = handleHour(hour, 0) + ":" + handleMinute(scope.status.tempDate.getMinutes(), 0);
                    scope.model = angular.copy(scope.status.tempDate);
                });
            }
            /**
             * [setMinute description] 设置分钟
             */
            function setMinute(minute) {
                $timeout(function() {
                    minute = Number(minute);
                    scope.data.minute1 = handleMinute(minute, -2);
                    scope.data.minute2 = handleMinute(minute, -1);
                    scope.data.minute3 = handleMinute(minute, 0);
                    scope.data.minute4 = handleMinute(minute, 1);
                    scope.data.minute5 = handleMinute(minute, 2);
                    scope.status.tempDate.setMinutes(scope.data.minute3);
                    scope.status.showDate = handleHour(scope.status.tempDate.getHours(), 0) + ":" + handleMinute(minute, 0);
                    scope.model = angular.copy(scope.status.tempDate);
                });
            }
            /**
             * [handleHour description] 处理消失
             * @return {[type]} [description]
             */
            function handleHour(hour, different) {
                hour += different;
                hour = hour >= 24 ? hour - 24 : hour;
                hour = hour < 0 ? 24 + hour : hour;
                hour = hour > 9 ? hour.toString() : "0" + hour;
                return hour;
            }
            /**
             * [handleMinute description] 设置分钟
             * @return {[type]} [description]
             */
            function handleMinute(minute, different) {
                minute += different;
                minute = minute >= 60 ? minute - 60 : minute;
                minute = minute < 0 ? 60 + minute : minute;
                minute = minute > 9 ? minute.toString() : "0" + minute;
                return minute;
            }
            /**
             * [initElemEvent description] 初始化输入框事件
             * @return {[type]} [description]
             */
            function initElemEvent() {
                $elem.bind("focus", function() {
                    $timeout(function() {
                        var bottom = $("body")[0].scrollHeight - ($elem.offset().top + $elem[0].offsetHeight);
                        var templateHeight = Number(scope.status.template.css("height").replace(/px/, ""));
                        var top = templateHeight > bottom ? -templateHeight : $elem[0].offsetHeight;
                        scope.status.style = {
                            top: $elem[0].offsetHeight, //top,
                            left: 0,
                            display: "block"
                        };
                        initData();
                    });
                });
                bindBody = function(e) {
                    var templateDisplay = scope.status.template.css("display");
                    if (templateDisplay !== "none" && $(e.target)[0] !== $elem[0] && $(e.target).parents(".trsTimepicker").length === 0) {
                        $timeout(function() {
                            scope.status.style.display = "none";
                            if (!scope.model) {
                                scope.model = new Date();
                            }
                        });
                    }
                };
                $("body").bind("click", bindBody);
            }
            scope.$on("$destroy", function() {
                $("body").unbind("click", bindBody);
            });

            function initTemplate() {
                var deffer = $q.defer();
                $templateRequest("./utils/dateTimePicker/trsTimepicker_tpl.html").then(function(template) {
                    scope.status.template = $compile(template)(scope);
                    scope.status.template.insertAfter($elem);
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [initMouseWheel description] 初始化鼠标滚动事件
             * @return {[type]} [description]
             */
            function initMouseWheel() {
                scope.status.template.find(".hour").bind("mousewheel", function(e) {
                    e.preventDefault();
                    var direction = e.originalEvent.wheelDeltaY > 0 ? 'up' : 'down';
                    scope.selectHour(direction);
                });
                scope.status.template.find(".minute").bind("mousewheel", function(e) {
                    e.preventDefault();
                    var direction = e.originalEvent.wheelDeltaY > 0 ? 'up' : 'down';
                    scope.selectMinute(direction);
                });
            }
        }
    };
}]);